// lodash
import isEmpty from 'lodash/isEmpty';
import { getCalendarAnalytics } from './getCalendarAnalytics';
import daysBetweenDateAndStartOfWeek from '../../helpers/date/daysBetweenDateAndStartOfWeek';
import { COLLECT_PLUS_OWNER_ID } from '../../../constants/clickCollectConstants';

export function getUnavailableStores(stores = []) {
  return stores.slice(0, 5).map((item, index) => ({ ...item, index: index + 1 }))
    .filter(store => !isEmpty(store.unavailabilityReason));
}

export function getUnavailableStoresAnalyticsInfo(item) {
  return item.storeName
    .concat(':', item.unavailabilityReason.replace('due to ', ''), ':', item.index)
    .toLocaleLowerCase();
}

export function selectClickAndCollectStoreAnalytics(
  store,
  searchTerm,
  collectionDates,
  selectedIndex,
) {
  let collectionDateAnalytics = {};

  if (!isEmpty(collectionDates)) {
    const dates = collectionDates.filter(date => date.isAvailable).map(
      filteredDate => filteredDate.date,
    );

    const firstDeliverySlot = daysBetweenDateAndStartOfWeek(dates[0]);

    // TODO refactor getCalendarAnalytics to be more generic
    collectionDateAnalytics = {
      ...getCalendarAnalytics({
        deliveryMethods: [{
          dates,
          methodId: '0',
          description: 'Click and Collect',
        }],
        calendarPageIndexObject: {
          0: 0,
        },
        daysToShowPerPage: 7,
        selectedDeliveryMethodId: '0',
      })[0],
      firstDeliverySlot,
      clickandCollectType: 'named day',
      slotSelected: '',
    };
  }

  const deliveryProposition = [{
    selected: 1,
    deliveryId: store.id,
    method: (store.ownerId === COLLECT_PLUS_OWNER_ID ? 'col:cp' : 'col:cc'),
    message: (store.ownerId === COLLECT_PLUS_OWNER_ID ? 'collect+' : 'click & collect'),
    searchTerm,
    ...collectionDateAnalytics,
    ...(selectedIndex && { shopSelected: selectedIndex }),
  }];

  return {
    checkout: {
      batch: [
        {
          deliveryProposition,
        },
      ],
    },
  };
}
